import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
    apiKey: "AIzaSyALEN71_enDv6cSGfSYJPNcRBTXa6l3Ux0",
    authDomain: "apilingua-28b61.firebaseapp.com",
    databaseURL: "https://apilingua-28b61-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "apilingua-28b61",
    storageBucket: "apilingua-28b61.firebasestorage.app",
    messagingSenderId: "1013747870908",
    appId: "1:1013747870908:web:33b3ec475ace86d8d6f4b9",
    measurementId: "G-HE3MG3CR84"
};

const app = initializeApp(firebaseConfig, "database");

export const db = getDatabase(app);